import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TramiteSicProteccionConsumidorDto } from '../../../../../dto/tramites/tramite-sic-proteccion-consumidor.dto';
import { ListaValorService } from '../services/lista-valor.service';
import { PrestacionServiciosDto } from '../../../../../dto/tramites/sic/prestacion-servicios.dto';
import { EfectividadGarantiaDto } from '../../../../../dto/tramites/sic/efectividad-garantia.dto';
import { ProteccionContractualDto } from '../../../../../dto/tramites/sic/proteccion-contractual.dto';
import { ViolacionDerechosConsumidorDto } from '../../../../../dto/tramites/sic/violacion-derechos-consumidor.dto';
import { FormField } from '../../../../../dto/util/form-field';
import {
  ListaValorRequestDto,
  ListaValorResponseDto,
} from '../../../../../dto/tramites/lista_valor.dto';
import { Constants } from '../../../../../constants/constants';
import { PublicadEnganosaDto } from '../../../../../dto/tramites/sic/publicad-enganosa.dto';
import { TranslateService } from '@ngx-translate/core';
import { AnexoPrecargaResponseDto } from "../../../../../dto/anexo/anexo-tramite.dto";
import { TipoAnexoTipoTramiteDto } from "../../../../util/archivos-tramite/dto/tipo-anexo-tipo-tramite.dto";
import { ArchivoItemDto } from "../../../../util/archivos-tramite/dto/ArchivoItemDto";
import { ProteccionConsumidorService } from "../services/proteccion-consumidor.service";
import { AlertaModalService } from '../../../../../services/util/alerta-modal.service';

@Component({
  selector: 'app-proteccion-que-requiere',
  templateUrl: './proteccion-que-requiere.component.html',
  styleUrl: './proteccion-que-requiere.component.scss',
})
export class ProteccionQueRequiereComponent implements OnInit, OnChanges {
  @Input() tramiteSic?: TramiteSicProteccionConsumidorDto;
  @Output() continuar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();
  @Output() guardarSinEnviar = new EventEmitter<{
    tramite: TramiteSicProteccionConsumidorDto;
    formValid: boolean;
    event: Event;
  }>();

  entidadId: number = Constants.ID_ENTIDAD_SIC;

  formTipoProteccion!: FormGroup;
  formPublicidadEnganosa!: FormGroup;
  formPrestacionServicios!: FormGroup;
  formEfectividadGarantia!: FormGroup;
  formProteccionContractual!: FormGroup;
  formViolacionDerechosConsumidor!: FormGroup;

  listaProteccionRequiere: ListaValorResponseDto[] = [];

  formFieldsTipoProteccion: FormField[] = [];

  formFieldsEfectividadGarantia: FormField[] = [];

  formFieldsPublicidadEnganosa: FormField[] = [];

  formFieldsPrestacionServicios: FormField[] = [];

  formFieldsProteccionContractual: FormField[] = [];

  formFieldsViolacionDerechosConsumidor: FormField[] = [];

  // Multilenguaje
  proconText: any = {};
  comunText: any = {};
  alertaText: any = {};

  // Archivos
  jsonReglaRequerido: any = {};
  archivosPrecargados: AnexoPrecargaResponseDto[] = [];
  idsArchivos: TipoAnexoTipoTramiteDto[] = [];
  archivosCargados: ArchivoItemDto[] = [];
  guardarArchivos = false;

  pesoTotalArchivosMB: string = '0.00';

  buildForms() {
    this.formFieldsTipoProteccion = [
      {
        name: 'tipoProteccion',
        label: this.proconText['tramite-sic-procon']['tipo-proteccion'],
        type: 'select',
        required: true,
        options: [],
        width: '12',
        visible: true,
        errorMessages: { required: this.proconText['seleccione-opcion'] },
      },
    ];

    this.formFieldsEfectividadGarantia = [
      {
        name: 'bienServicio',
        label: this.proconText['tramite-sic-procon']['bien-servicio'],
        type: 'textarea',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['bien-servicio'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'precioPagado',
        label: this.proconText['tramite-sic-procon']['precio-pagado'],
        type: 'text',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['precio-pagado'],
        validation: [
          Validators.maxLength(20),
          Validators.pattern(Constants.REGEX_TELEFONO)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          maxlength:
            this.proconText['tramite-sic-procon']['precio-pagado-maxlength'],
          pattern: this.proconText['tramite-sic-procon']['precio-pattern']
        },
      },
      {
        name: 'descripcionInconformidad',
        label:
          this.proconText['tramite-sic-procon']['descripcion-inconformidad'],
        type: 'textarea',
        required: true,
        validation: [Validators.minLength(10)],
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-inconformidad'],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'fechaOcurrencia',
        label: this.proconText['tramite-sic-procon']['fecha-ocurrencia'],
        type: 'date',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['fecha-ocurrencia'],
        width: '12',
        visible: true,
        isMaxDate: true,
        errorMessages: {
          required:
            this.proconText['tramite-sic-procon']['fecha-ocurrencia-required'],
        },
      },
      {
        name: 'descripcionDatosRelevantes',
        label:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        type: 'textarea',
        required: true,
        validation: [Validators.minLength(10)],
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
    ];

    this.formFieldsPublicidadEnganosa = [
      {
        name: 'descripcionProducto',
        label: this.proconText['tramite-sic-procon']['descripcion-producto'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-producto'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'contenidoPublicidad',
        label: this.proconText['tramite-sic-procon']['contenido-publicidad'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['contenido-publicidad'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionGeneral',
        label: this.proconText['tramite-sic-procon']['descripcion-general'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-general'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionDatosRelevantes',
        label:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'tienePruebas',
        label: this.proconText['tramite-sic-procon']['tiene-pruebas'],
        type: 'select',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['tiene-pruebas'],
        options: [
          { Nombre: this.comunText['opcion-no'], Id: 'NO' },
          { Nombre: this.comunText['opcion-si'], Id: 'SI' },
        ],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['seleccione-opcion'],
        },
      },
      {
        name: 'infoPublicidad',
        label: this.proconText['tramite-sic-procon']['info-publicidad'],
        type: 'textarea',
        placeholder: this.proconText['tramite-sic-procon']['info-publicidad'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
        dependsOn: 'tienePruebas',
        visibilityCondition: value => value == 'NO',
      },
    ];

    this.formFieldsPrestacionServicios = [
      {
        name: 'descripcionServicioContratado',
        label:
          this.proconText['tramite-sic-procon'][
          'descripcion-servicio-contratado'
          ],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon'][
          'descripcion-servicio-contratado'
          ],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionBien',
        label: this.proconText['tramite-sic-procon']['descripcion-bien'],
        type: 'textarea',
        required: true,
        validation: [Validators.minLength(10)],
        placeholder: this.proconText['tramite-sic-procon']['descripcion-bien'],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'fechaEntregaBien',
        label: this.proconText['tramite-sic-procon']['fecha-entrega-bien'],
        type: 'date',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['fecha-entrega-bien'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['seleccione-fecha'],
        },
      },
      {
        name: 'estadoBien',
        label: this.proconText['tramite-sic-procon']['estado-bien'],
        type: 'textarea',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['estado-bien'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionDanos',
        label: this.proconText['tramite-sic-procon']['descripcion-danos'],
        type: 'textarea',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['descripcion-danos'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'causaDanos',
        label: this.proconText['tramite-sic-procon']['causa-danos'],
        type: 'textarea',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['causa-danos'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionDatosRelevantes',
        label:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
    ];

    this.formFieldsProteccionContractual = [
      {
        name: 'contratoDemanda',
        label: this.proconText['tramite-sic-procon']['contrato-demanda'],
        type: 'textarea',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['contrato-demanda'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionContratoCelebrado',
        label:
          this.proconText['tramite-sic-procon'][
          'descripcion-contrato-celebrado'
          ],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon'][
          'descripcion-contrato-celebrado'
          ],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'inconformidadesContrato',
        label:
          this.proconText['tramite-sic-procon']['inconformidades-contrato'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['inconformidades-contrato'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionManifiestoClausula',
        label:
          this.proconText['tramite-sic-procon'][
          'descripcion-manifiesto-clausula'
          ],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon'][
          'descripcion-manifiesto-clausula'
          ],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionDatosRelevantes',
        label:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
    ];

    this.formFieldsViolacionDerechosConsumidor = [
      {
        name: 'descripcionContratoRelacion',
        label:
          this.proconText['tramite-sic-procon'][
          'descripcion-contrato-relacion'
          ],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon'][
          'descripcion-contrato-relacion'
          ],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'derechoViolado',
        label: this.proconText['tramite-sic-procon']['derecho-violado'],
        type: 'textarea',
        required: true,
        placeholder: this.proconText['tramite-sic-procon']['derecho-violado'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionCircunstancias',
        label:
          this.proconText['tramite-sic-procon']['descripcion-circunstancias'],
        type: 'textarea',
        required: true,
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-circunstancias'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
      {
        name: 'descripcionDatosRelevantes',
        label:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        type: 'textarea',
        required: false,
        placeholder:
          this.proconText['tramite-sic-procon']['descripcion-datos-relevantes'],
        validation: [Validators.minLength(10)],
        width: '12',
        visible: true,
        errorMessages: {
          required: this.proconText['tramite-sic-procon']['campo-requerido'],
          minlength:
            this.proconText['tramite-sic-procon']['bien-servicio-minlength'],
        },
      },
    ];
  }

  constructor(
    private fb: FormBuilder,
    private listaValorService: ListaValorService,
    private readonly translate: TranslateService,
    private readonly proteccionConsumidorService: ProteccionConsumidorService,
    private readonly alertaModalService: AlertaModalService
  ) { }

  ngOnInit() {
    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.proconText[key] = text[key];
      }
      this.buildForms();
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
      this.buildForms();
    });
    this.translate.stream('alertas').forEach(text => {
      for (const key of Object.keys(text)) {
        this.alertaText[key] = text[key];
      }
    });
    this.formTipoProteccion = this.fb.group({
      tipoProteccion: ['', Validators.required],
    });

    this.formEfectividadGarantia = this.fb.group({
      bienServicio: ['', Validators.required],
    });

    this.formPublicidadEnganosa = this.fb.group({
      descripcionDatosRelevantes: ['', Validators.required],
    });

    this.formPrestacionServicios = this.fb.group({
      descripcionServicioContratado: ['', Validators.required],
    });

    this.formProteccionContractual = this.fb.group({
      contratoDemanda: ['', Validators.required],
    });

    this.formViolacionDerechosConsumidor = this.fb.group({
      descripcionContratoRelacion: ['', Validators.required],
    });

    this.listaValor();
  }

  ngOnChanges(changes: SimpleChanges) {
    const tramite: TramiteSicProteccionConsumidorDto =
      changes['tramiteSic'].currentValue;

    //Si el tramite cambia, se setea toda la informacion del mismo
    if (tramite !== undefined) {
      if (tramite.anexos && tramite.anexos.length > 0) {
        this.archivosPrecargados = tramite.anexos.filter(
          archivo =>
            archivo.tipoAnexoTipoTramite.orden == 4
        );
        if (this.tramiteSic?.anexos) {
          this.tramiteSic?.anexos.forEach(element => {
            if (element.tipoAnexoTipoTramite.orden == 4) {
              this.guardarArchivos = false;
            }
          });
        }
      } else {
        if (this.archivosPrecargados.length > 0) {
          this.guardarArchivos = true;
        }
      }
      if (this.archivosPrecargados === undefined || this.archivosPrecargados.length === 0) {
        if (this.tramiteSic) {
          this.proteccionConsumidorService
            .cargarTramitePendiente(+this.tramiteSic.id!)
            .subscribe((resp: TramiteSicProteccionConsumidorDto) => {
              if (resp.anexos) {
                this.archivosPrecargados = resp.anexos.filter(
                  archivo =>
                    archivo.tipoAnexoTipoTramite.orden == 4
                );
              }
            });
        }
      }
      if (tramite.tipoProteccion?.idProteccion !== undefined) {
        const item = this.listaProteccionRequiere.find(
          item => item.Id === tramite.tipoProteccion?.idProteccion
        );

        this.formFieldsTipoProteccion = this.formFieldsTipoProteccion.map(
          field => {
            if (field.name === 'tipoProteccion') {
              field.value = `${item?.Codigo}`;
            }
            return field;
          }
        );
        setTimeout(() => {
          this.formTipoProteccion.patchValue({
            tipoProteccion: item?.Codigo,
          });
        }, 300);

        if (item?.Codigo === 'PR_EG') {
          this.formFieldsEfectividadGarantia =
            this.formFieldsEfectividadGarantia.map(field => {
              if (field.name === 'bienServicio') {
                field.value = `${(tramite.tipoProteccion as { bienServicio: string }).bienServicio}`;
              }
              if (field.name === 'precioPagado') {
                field.value = `${(tramite.tipoProteccion as { precioPagado: string }).precioPagado}`;
              }
              if (field.name === 'descripcionInconformidad') {
                field.value = `${(
                  tramite.tipoProteccion as {
                    descripcionInconformidad: string;
                  }
                ).descripcionInconformidad
                  }`;
              }
              if (field.name === 'fechaOcurrencia') {
                field.value = this.setDateValue(
                  (
                    tramite.tipoProteccion as { fechaOcurrencia: string }
                  ).fechaOcurrencia.toString()
                );
              }
              if (field.name === 'descripcionDatosRelevantes') {
                field.value = `${tramite.tipoProteccion?.descripcionDatosRelevantes}`;
              }
              return field;
            });

          this.formEfectividadGarantia.patchValue({
            descripcionDatosRelevantes: `${tramite.tipoProteccion?.descripcionDatosRelevantes}`,
            precioPagado: `${(tramite.tipoProteccion as { precioPagado: string }).precioPagado}`,
            descripcionInconformidad: `${(
              tramite.tipoProteccion as {
                descripcionInconformidad: string;
              }
            ).descripcionInconformidad
              }`,
            fechaOcurrencia: `${this.setDateValue(
              (
                tramite.tipoProteccion as {
                  fechaOcurrencia: string;
                }
              ).fechaOcurrencia.toString()
            )}`,
          });
        }

        if (item?.Codigo === 'PR_PIE') {
          this.formFieldsPublicidadEnganosa =
            this.formFieldsPublicidadEnganosa.map(field => {
              if (field.name === 'descripcionProducto') {
                field.value = `${(tramite.tipoProteccion as { descripcionProducto: string }).descripcionProducto}`;
              }
              if (field.name === 'contenidoPublicidad') {
                field.value = `${(tramite.tipoProteccion as { contenidoPublicidad: string }).contenidoPublicidad}`;
              }
              if (field.name === 'descripcionGeneral') {
                field.value = `${(tramite.tipoProteccion as { descripcionGeneral: string }).descripcionGeneral}`;
              }
              if (field.name === 'descripcionDatosRelevantes') {
                field.value = `${tramite.tipoProteccion?.descripcionDatosRelevantes}`;
              }
              if (field.name === 'tienePruebas') {
                field.value =
                  Number(
                    (
                      tramite.tipoProteccion as {
                        tienePruebas: string;
                      }
                    ).tienePruebas
                  ) === 1
                    ? 'SI'
                    : 'NO';
              }
              if (field.name === 'infoPublicidad') {
                field.value = `${(tramite.tipoProteccion as { infoPublicidad: string })
                  .infoPublicidad !== undefined
                  ? (tramite.tipoProteccion as { infoPublicidad: string })
                    .infoPublicidad
                  : ''
                  }`;
              }

              return field;
            });

          this.formPublicidadEnganosa.patchValue({
            descripcionDatosRelevantes:
              tramite.tipoProteccion?.descripcionDatosRelevantes,
            descripcionGeneral: (
              tramite.tipoProteccion as { descripcionGeneral: string }
            ).descripcionGeneral,
            contenidoPublicidad: (
              tramite.tipoProteccion as { contenidoPublicidad: string }
            ).contenidoPublicidad,
            descripcionProducto: (
              tramite.tipoProteccion as { descripcionProducto: string }
            ).descripcionProducto,
            tienePruebas:
              Number(
                (tramite.tipoProteccion as { tienePruebas: string })
                  .tienePruebas
              ) === 1
                ? 'SI'
                : 'NO',
            infoPublicidad:
              (tramite.tipoProteccion as { infoPublicidad: string })
                .infoPublicidad !== undefined
                ? (tramite.tipoProteccion as { infoPublicidad: string })
                  .infoPublicidad
                : '',
          });
        }

        if (item?.Codigo === 'PR_PSIB') {
          this.formFieldsPrestacionServicios =
            this.formFieldsPrestacionServicios.map(field => {
              if (field.name === 'descripcionServicioContratado') {
                field.value = `${(
                  tramite.tipoProteccion as {
                    descripcionServicioContratado: string;
                  }
                ).descripcionServicioContratado
                  }`;
              }
              if (field.name === 'descripcionBien') {
                field.value = `${(tramite.tipoProteccion as { descripcionBien: string }).descripcionBien}`;
              }
              if (field.name === 'fechaEntregaBien') {
                field.value = this.setDateValue(
                  (
                    tramite.tipoProteccion as { fechaEntregaBien: string }
                  ).fechaEntregaBien.toString()
                );
              }
              if (field.name === 'estadoBien') {
                field.value = `${(tramite.tipoProteccion as { estadoBien: string }).estadoBien}`;
              }
              if (field.name === 'descripcionDanos') {
                field.value = `${(tramite.tipoProteccion as { descripcionDanos: string }).descripcionDanos}`;
              }
              if (field.name === 'causaDanos') {
                field.value = `${(tramite.tipoProteccion as { causaDanos: string }).causaDanos}`;
              }
              if (field.name === 'descripcionDatosRelevantes') {
                field.value = `${tramite.tipoProteccion?.descripcionDatosRelevantes}`;
              }
              return field;
            });

          this.formEfectividadGarantia.patchValue({
            descripcionServicioContratado: (
              tramite.tipoProteccion as {
                descripcionServicioContratado: string;
              }
            ).descripcionServicioContratado,
            descripcionBien: (
              tramite.tipoProteccion as { descripcionBien: string }
            ).descripcionBien,
            fechaEntregaBien: this.setDateValue(
              (
                tramite.tipoProteccion as { fechaEntregaBien: string }
              ).fechaEntregaBien.toString()
            ),
            estadoBien: (tramite.tipoProteccion as { estadoBien: string })
              .estadoBien,
            descripcionDanos: (
              tramite.tipoProteccion as { descripcionDanos: string }
            ).descripcionDanos,
            causaDanos: (tramite.tipoProteccion as { causaDanos: string })
              .causaDanos,
            descripcionDatosRelevantes:
              tramite.tipoProteccion?.descripcionDatosRelevantes,
          });
        }

        if (item?.Codigo === 'PR_PC') {
          this.formFieldsProteccionContractual =
            this.formFieldsProteccionContractual.map(field => {
              if (field.name === 'contratoDemanda') {
                field.value = `${(tramite.tipoProteccion as { contratoDemanda: string }).contratoDemanda}`;
              }
              if (field.name === 'descripcionContratoCelebrado') {
                field.value = `${(
                  tramite.tipoProteccion as {
                    descripcionContratoCelebrado: string;
                  }
                ).descripcionContratoCelebrado
                  }`;
              }
              if (field.name === 'inconformidadesContrato') {
                field.value = `${(
                  tramite.tipoProteccion as {
                    inconformidadesContrato: string;
                  }
                ).inconformidadesContrato
                  }`;
              }
              if (field.name === 'descripcionManifiestoClausula') {
                field.value = `${(
                  tramite.tipoProteccion as {
                    descripcionManifiestoClausula: string;
                  }
                ).descripcionManifiestoClausula
                  }`;
              }
              if (field.name === 'descripcionDatosRelevantes') {
                field.value = `${tramite.tipoProteccion?.descripcionDatosRelevantes}`;
              }

              return field;
            });

          this.formEfectividadGarantia.patchValue({
            contratoDemanda: (
              tramite.tipoProteccion as { contratoDemanda: string }
            ).contratoDemanda,
            descripcionContratoCelebrado: (
              tramite.tipoProteccion as {
                descripcionContratoCelebrado: string;
              }
            ).descripcionContratoCelebrado,
            inconformidadesContrato: (
              tramite.tipoProteccion as {
                inconformidadesContrato: string;
              }
            ).inconformidadesContrato,
            descripcionManifiestoClausula: (
              tramite.tipoProteccion as {
                descripcionManifiestoClausula: string;
              }
            ).descripcionManifiestoClausula,
            descripcionDatosRelevantes:
              tramite.tipoProteccion?.descripcionDatosRelevantes,
          });
        }

        if (item?.Codigo === 'PR_PVDC') {
          this.formFieldsViolacionDerechosConsumidor =
            this.formFieldsViolacionDerechosConsumidor.map(field => {
              if (field.name === 'descripcionContratoRelacion') {
                field.value = `${(
                  tramite.tipoProteccion as {
                    descripcionContratoRelacion: string;
                  }
                ).descripcionContratoRelacion
                  }`;
              }
              if (field.name === 'derechoViolado') {
                field.value = `${(tramite.tipoProteccion as { derechoViolado: string }).derechoViolado}`;
              }
              if (field.name === 'descripcionCircunstancias') {
                field.value = `${(
                  tramite.tipoProteccion as {
                    descripcionCircunstancias: string;
                  }
                ).descripcionCircunstancias
                  }`;
              }
              if (field.name === 'descripcionDatosRelevantes') {
                field.value = `${tramite.tipoProteccion?.descripcionDatosRelevantes}`;
              }

              return field;
            });

          this.formEfectividadGarantia.patchValue({
            descripcionContratoRelacion: (
              tramite.tipoProteccion as {
                descripcionContratoRelacion: string;
              }
            ).descripcionContratoRelacion,
            derechoViolado: (
              tramite.tipoProteccion as { derechoViolado: string }
            ).derechoViolado,
            descripcionCircunstancias: (
              tramite.tipoProteccion as {
                descripcionCircunstancias: string;
              }
            ).descripcionCircunstancias,
            descripcionDatosRelevantes:
              tramite.tipoProteccion?.descripcionDatosRelevantes,
          });
        }
      }
    }
  }

  listaValor() {
    this.listaValorService.lista('SIC_PROTECCION_REQUIERE').subscribe(data => {
      const response = data as ListaValorResponseDto[];
      this.listaProteccionRequiere = response;

      this.formFieldsTipoProteccion = this.formFieldsTipoProteccion.map(
        field => {
          if (field.name === 'tipoProteccion') {
            field.options = response
              .sort((a, b) => a.Otro_valor!.localeCompare(b.Otro_valor!))
              .map((item: ListaValorResponseDto) => ({
                Id: item.Codigo!,
                Nombre: item.Valor!,
              }));
          }
          return field;
        }
      );
    });
  }

  validarFormularioTipoProteccion(formGroup: FormGroup) {
    this.formTipoProteccion = formGroup;
    this.jsonReglaRequerido = {
      tipoProteccion: this.formTipoProteccion?.get('tipoProteccion')?.value
    }
  }

  validarFormularioPublicidadEnganosa(formGroup: FormGroup) {
    this.formPublicidadEnganosa = formGroup;

    this.jsonReglaRequerido = {
      tipoProteccion: this.formTipoProteccion.get('tipoProteccion')?.value,
      tienePruebas: this.formPublicidadEnganosa?.get("tienePruebas")?.value,
    }
  }

  validarFormularioPrestacionServicios(formGroup: FormGroup) {
    this.formPrestacionServicios = formGroup;
  }

  validarFormularioEfectividadGarantia(formGroup: FormGroup) {
    this.formEfectividadGarantia = formGroup;
  }

  validarFormularioProteccionContractual(formGroup: FormGroup) {
    this.formProteccionContractual = formGroup;
  }

  validarFormularioViolacionDerechosConsumidor(formGroup: FormGroup) {
    this.formViolacionDerechosConsumidor = formGroup;
  }

  // Función que almacena los archivos requeridos por cada uno de los pasos
  validarArchivosRequeridos(evento: { archivos: TipoAnexoTipoTramiteDto[]; paso: number }) {
    this.idsArchivos = this.buscarRequeridos(evento.archivos);
  }
  // Función que retorna los archivos con la propiedad de requerido = true
  buscarRequeridos(archivos: TipoAnexoTipoTramiteDto[]) {
    archivos = archivos.filter(
      (anexo: any) => anexo.requerido === true
    );
    return archivos;
  }

  validarArchivosCargados(archivos: ArchivoItemDto[]) {
    const data = archivos;
    const unicos = Array.from(
      new Map(data.map(obj => [obj.item.id, obj])).values()
    );
    let total = 0;
    this.archivosCargados = unicos;
    unicos.forEach(element => {
      element.files.forEach(item => {
        total = total + item.size;
      })
      this.pesoTotalArchivosMB = (total / (1024 * 1024)).toFixed(2);
    });
    if (this.formTipoProteccion) {
      // Se valida si el tipo de protección seleccionado es: Protección contractual
      if (this.formTipoProteccion.get('tipoProteccion')?.value == 'PR_PC') {
        // Se eliminan los archivos de publicidad engañosa, porque ya no aplica para este tipo de protección
        this.archivosCargados = this.archivosCargados.filter(item => item.item.nombreAnexo !== 'Publicidad_Engañosa');
      }
      // Se valida si el tipo de protección seleccionado es: Reconocimiento y pago
      // de los perjuicios causados como consecuencia de publicidad e información engañosa
      if (this.formTipoProteccion.get('tipoProteccion')?.value == 'PR_PIE') {
        // Se eliminan los archivos de contrato, porque ya no aplica para este tipo de protección
        this.archivosCargados = this.archivosCargados.filter(item => item.item.nombreAnexo !== 'Contrato');
      }
    }
  }

  get pesoArchivos(): string {
    return this.pesoTotalArchivosMB;
  }

  anterior() {
    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      paso--;
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(paso));
    }
  }

  pasarAPretenciones(e: Event, guardarSinEnviar: boolean) {

    const tipo = this.formTipoProteccion.value['tipoProteccion'];

    // Validar formulario
    const formEsValido = this.isSelectedFormValid();

    // Validar archivos
    const archivosValidos = this.isSelectedFilesValid();


    if (!formEsValido) {

      // Marcar formulario seleccionado como touched
      switch (tipo) {
        case 'PR_EG':
          this.formEfectividadGarantia.markAllAsTouched();
          break;
        case 'PR_PIE':
          this.formPublicidadEnganosa.markAllAsTouched();
          break;
        case 'PR_PSIB':
          this.formPrestacionServicios.markAllAsTouched();
          break;
        case 'PR_PC':
          this.formProteccionContractual.markAllAsTouched();
          break;
        case 'PR_PVDC':
          this.formViolacionDerechosConsumidor.markAllAsTouched();
          break;
      }

      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['form_invalid']
      );
      return;
    }

    if (!archivosValidos) {
      this.alertaModalService.error(
        this.alertaText['error'],
        this.alertaText['archivos_obligatorios']
      );
      return;
    }

    let paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    if (paso) {
      sessionStorage.setItem(Constants.PASOS, JSON.stringify(5));
    }
    const tramite: TramiteSicProteccionConsumidorDto = {};
    this.guardarArchivos = true;
    switch (this.formTipoProteccion.value['tipoProteccion']) {
      case 'PR_EG':
        tramite.tipoProteccion = this.mapEfectividadGarantiaToDTO();
        break;
      case 'PR_PIE':
        tramite.tipoProteccion = this.mapPublicidadEnganosaToDTO();
        break;
      case 'PR_PSIB':
        tramite.tipoProteccion = this.mapPrestacionServiciosToDTO();
        break;
      case 'PR_PC':
        tramite.tipoProteccion = this.mapProteccionContractualToDTO();
        break;
      case 'PR_PVDC':
        tramite.tipoProteccion = this.mapViolacionDerechosConsumidorToDTO();
        break;
    }

    const formValid =
      this.formTipoProteccion.valid || this.isSelectedFormValid();
    if (!guardarSinEnviar) {
      setTimeout(() => {
        this.continuar.emit({
          tramite: tramite,
          formValid,
          event: e,
        });
      }, 600);
    } else {
      setTimeout(() => {
        this.guardarSinEnviar.emit({
          tramite: tramite,
          formValid,
          event: e,
        });
      }, 600);
    }
  }

  isSelectedFormValid(): boolean {
    switch (this.formTipoProteccion.value['tipoProteccion']) {
      case 'PR_EG':
        return this.formEfectividadGarantia.valid;
      case 'PR_PIE':
        return this.validarPubliciadadEnganosa();
      case 'PR_PSIB':
        return this.formPrestacionServicios.valid;
      case 'PR_PC':
        return this.formProteccionContractual.valid && this.validacionArchivos();
      case 'PR_PVDC':
        return this.formViolacionDerechosConsumidor.valid;
      default:
        return false;
    }
  }

  validarPubliciadadEnganosa(): boolean {
    if (this.formPublicidadEnganosa.get('tienePruebas')?.value == 'NO') {
      return this.formPublicidadEnganosa.valid;
    } else {
      return (
        this.formPublicidadEnganosa.valid &&
        this.validacionArchivos()
      );
    }
  }

  validacionArchivos(): boolean {
    const archivos: File[] = []

    this.archivosCargados.map((item) => {
      item.files.map((file) => {
        archivos.push(file)
      })
    })

    return archivos.length > 0
  }

  private isSelectedFilesValid(): boolean {
    const tipo = this.formTipoProteccion.value['tipoProteccion'];

    if (tipo === 'PR_PC') {
      return this.validacionArchivos();
    }
    if (tipo === 'PR_PIE') {
      if (this.formPublicidadEnganosa.get('tienePruebas')?.value === 'SI') {
        return this.validacionArchivos();
      }
    }

    return true;
  }

  mapPublicidadEnganosaToDTO(): PublicadEnganosaDto {
    return {
      descripcionDatosRelevantes:
        this.formPublicidadEnganosa.value['descripcionDatosRelevantes'],
      descripcionGeneral:
        this.formPublicidadEnganosa.value['descripcionGeneral'],
      contenidoPublicidad:
        this.formPublicidadEnganosa.value['contenidoPublicidad'],
      descripcionProducto:
        this.formPublicidadEnganosa.value['descripcionProducto'],
      idProteccion: this.getListaValor().id,
      tienePruebas:
        this.formPublicidadEnganosa.value['tienePruebas']?.[0] === 'S' ? 1 : 0,
      infoPublicidad: this.formPublicidadEnganosa.value['infoPublicidad'],
      tipoProteccion: this.getListaValor(),
    };
  }

  mapPrestacionServiciosToDTO(): PrestacionServiciosDto {
    return {
      descripcionServicioContratado:
        this.formPrestacionServicios.value['descripcionServicioContratado'],
      descripcionBien: this.formPrestacionServicios.value['descripcionBien'],
      fechaEntregaBien: this.formPrestacionServicios.value['fechaEntregaBien'],
      estadoBien: this.formPrestacionServicios.value['estadoBien'],
      descripcionDanos: this.formPrestacionServicios.value['descripcionDanos'],
      causaDanos: this.formPrestacionServicios.value['causaDanos'],
      descripcionDatosRelevantes:
        this.formPrestacionServicios.value['descripcionDatosRelevantes'],
      idProteccion: this.getListaValor().id,
      tipoProteccion: this.getListaValor(),
    };
  }

  mapEfectividadGarantiaToDTO(): EfectividadGarantiaDto {
    let precioPagado = this.formEfectividadGarantia.value['precioPagado'];
    return {
      bienServicio: this.formEfectividadGarantia.value['bienServicio'],
      descripcionDatosRelevantes:
        this.formEfectividadGarantia.value['descripcionDatosRelevantes'],
      precioPagado: precioPagado == undefined ? 0 : Number(this.formEfectividadGarantia.value['precioPagado']),
      descripcionInconformidad:
        this.formEfectividadGarantia.value['descripcionInconformidad'],
      fechaOcurrencia: this.formEfectividadGarantia.value['fechaOcurrencia'],
      idProteccion: this.getListaValor().id,
      tipoProteccion: this.getListaValor(),
    };
  }

  mapProteccionContractualToDTO(): ProteccionContractualDto {
    return {
      contratoDemanda: this.formProteccionContractual.value['contratoDemanda'],
      descripcionContratoCelebrado:
        this.formProteccionContractual.value['descripcionContratoCelebrado'],
      inconformidadesContrato:
        this.formProteccionContractual.value['inconformidadesContrato'],
      descripcionManifiestoClausula:
        this.formProteccionContractual.value['descripcionManifiestoClausula'],
      descripcionDatosRelevantes:
        this.formProteccionContractual.value['descripcionDatosRelevantes'],
      idProteccion: this.getListaValor().id,
      tipoProteccion: this.getListaValor(),
    };
  }

  mapViolacionDerechosConsumidorToDTO(): ViolacionDerechosConsumidorDto {
    return {
      descripcionContratoRelacion:
        this.formViolacionDerechosConsumidor.value[
        'descripcionContratoRelacion'
        ],
      derechoViolado:
        this.formViolacionDerechosConsumidor.value['derechoViolado'],
      descripcionCircunstancias:
        this.formViolacionDerechosConsumidor.value['descripcionCircunstancias'],
      descripcionDatosRelevantes:
        this.formViolacionDerechosConsumidor.value[
        'descripcionDatosRelevantes'
        ],
      idProteccion: this.getListaValor().id,
      tipoProteccion: this.getListaValor(),
    };
  }

  getListaValor(): ListaValorRequestDto {
    const item = this.listaProteccionRequiere.find(
      item => item.Codigo === this.formTipoProteccion.value['tipoProteccion']
    );

    return {
      valor: item?.Valor,
      estado: item?.Estado,
      nombreLista: item?.Nombre_Lista,
      codigo: item?.Codigo,
      otroValor: item?.Otro_valor,
      idExterno: item?.Id_Externo,
      id: item?.Id,
    };
  }

  setDateValue(dateString: string): string | undefined {
    if (!dateString) return; // Manejo de caso nulo o vacío
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      console.warn(`Fecha inválida: ${dateString}`);
      return;
    } else {
      const formattedDate = date.toISOString().split('T')[0]; // Formato yyyy-MM-dd
      return formattedDate;
    }
  }

  showPesoArchivos(): boolean {
    const paso = +JSON.parse(sessionStorage.getItem(Constants.PASOS)!);
    const tipoProteccion = this.formTipoProteccion.get('tipoProteccion')?.value;
    const tienePruebas = this.formPublicidadEnganosa.get('tienePruebas')?.value;
    if (paso === 4) {
      const cumpleCondicion =
        (tipoProteccion === 'PR_PIE' && tienePruebas === 'SI') ||
        tipoProteccion === 'PR_PC';

      if (cumpleCondicion) {
        const hayArchivos =
          (this.archivosPrecargados?.length ?? 0) > 0 ||
          (this.archivosCargados?.length ?? 0) > 0;

        return hayArchivos;
      }
    }

    return false;
  }

  // Documentos
  subirArchivo(subio: any) {
    this.guardarArchivos = false;
    if (subio) {
    }
  }

  protected readonly JSON = JSON;
  protected readonly Constants = Constants;
}
